import { TmcContextService } from './../../../../common/tmc-context.service';
import { TransportDetailsLayoutConverter } from './../../../../common/components/tmp/transport-details-layout-converter.service';
import { Component, Input } from '@angular/core';
import { TransportAssignmentSight } from '../action-tablet-planned-assignments.model';
import { TransportDetailLayout, TransportDetailMode } from './../../../../common/configuration/transport.configuration';
import { AppClientConfigurationService, AppServerAPI, DateUtilsService } from '@sdbn/common';
import { MatDialog } from '@angular/material/dialog';
import { VisitService } from '../../../visit-overview/service/visit.service';
import { TransportDetailsLayoutService } from '../../../transport-details/transport-details-layout.service';
import { Station } from '../../../../../yard/client/model/station';

@Component({
  selector: 'yard-action-tablet-planned-assignment-details',
  templateUrl: './action-tablet-planned-assignment-details.component.html',
  styleUrls: ['./action-tablet-planned-assignment-details.component.scss']
})
export class ActionTabletPlannedAssignmentDetailsComponent {

  TransportDetailMode = TransportDetailMode;

  layoutDefinition: TransportDetailLayout;

  station: Station;

  transportAssignmentSight: TransportAssignmentSight;
  @Input('transportAssignmentSight') set setTransportAssignmentSight(value: TransportAssignmentSight) {
    this.transportAssignmentSight = value;
    if (this.transportAssignmentSight?.stationId != null) {
      this.station = this.tmcContextService.findStationById(this.transportAssignmentSight.stationId);
    }
  }

  constructor(
    public cps: AppClientConfigurationService,
    private appServerApi: AppServerAPI,
    private dialog: MatDialog,
    private visitService: VisitService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter,
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    public dateUtilsService: DateUtilsService,
    private tmcContextService: TmcContextService
  ) {

    this.layoutDefinition = transportDetailsLayoutConverter.convert(
      this.transportDetailsLayoutService.createStationAssignmentTransportDetailsGridLayout()
    );

    tmcContextService.updated.subscribe(() => {
      if (this.transportAssignmentSight?.stationId != null) {
        this.station = tmcContextService.findStationById(this.transportAssignmentSight.stationId);
      }
    });

  }

}
